import { IconButton, IconButtonProps } from "../iconButton/IconButton";
import { useActiveSheet } from "./ActiveSheetContext";

export function ExpandSheetButton(
  props: Omit<IconButtonProps, "onClick" | "aria-label" | "iconName">
) {
  const { sheet } = useActiveSheet();

  const previousSheet = sheet?.getPreviousSheet();

  if (!previousSheet) return;

  return (
    <IconButton
      {...props}
      onClick={previousSheet.toggleCollapse}
      aria-label={previousSheet.isCollapsed ? "Expand sheet" : "Collapse sheet"}
      iconName={previousSheet.isCollapsed ? "chevron-down" : "chevron-up"}
    />
  );
}
